import { Component, HostBinding } from '@angular/core';
import { versions } from 'src/environments/version';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	@HostBinding('class.print-hide')
	public readonly printHide = true;

	versions = versions;
}
